// Public slugs identify a restaurant in its menu URL and QR code, so they must stay stable once issued.

/** Paths a slug must never shadow if the public menu is served at `/:slug` on its own host. */
export const RESERVED_SLUGS = new Set([
  "api",
  "app",
  "m",
  "admin",
  "internal",
  "login",
  "logout",
  "inregistrare",
  "resetare-parola",
  "verificare-email",
  "preturi",
  "termeni",
  "confidentialitate",
  "assets",
  "static",
  "health",
  "meniova",
  "www",
]);

export const SLUG_MAX_LENGTH = 48;

/** Removes diacritics (incl. Romanian ș/ş, ț/ţ) and produces a lower-case, hyphenated ASCII slug. */
const COMBINING_MARKS = /\p{M}/gu;

export function slugify(input: string): string {
  const ascii = input
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .replace(/[șş]/gi, "s")
    .replace(/[țţ]/gi, "t")
    .toLowerCase();
  const slug = ascii
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, SLUG_MAX_LENGTH)
    .replace(/-+$/g, "");
  return slug;
}

/** Normalises text for diacritic-insensitive search and name matching. */
export function normalizeForSearch(input: string): string {
  return input.normalize("NFD").replace(COMBINING_MARKS, "").toLowerCase().trim();
}
